
<template>
    <div class="page">

        <!-- <left-sidebar></left-sidebar> -->
        <div>
            <div class="sidebar-wrapper">
                <h3>Файли</h3>
                <ul class="ul-sidebar">

                    <li class="active"><router-link :to="{ name: 'system-files' }"> Всички файли </router-link></li>
                 <li class="active"><router-link :to="{ name: 'system-files-pdf', params: { type: 'pdf' }  }">Файли PDF </router-link></li>
                 <li class="active"><router-link :to="{ name: 'system-files-video', params: { type: 'pdf' }  }">Файли Video </router-link></li>

             </ul>

         </div>
     </div>

     <div class="page-content-wrap">
        <nav class="">
            <div>
              <div v-if="checkBoxesState" style="margin-bottom: 1rem;">
                <ul class="breadcrumbs remaining-count">
                 <li>
                    <input @change="checkAll()" type="checkbox" :checked="checkBoxesState" id="aaaaaaa" class="cbx" style="display: none;">
                    <label for="aaaaaaa" class="check">
                      <svg width="14px" height="14px" viewBox="0 0 18 18">
                        <path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z"></path>
                        <polyline points="1 9 7 14 15 4"></polyline>
                    </svg>
                </label>
            </li>
            <li class="color-checked">{{ checkBoxesState }} checked items</li>
        </ul>
    </div>

    <ul v-else class="breadcrumbs" >
        <li class="c-pointer path-line" @click="backFolder()"> <i data-v-9c16672c="" aria-hidden="true" class="fa fa-arrow-left"> </i> home{{ newPath }}</li>
    </ul>


    <ul class="buttons-do l-fe" v-if="!checkBoxesState">

        <li v-if="this.$route.params.type == 'pdf'"><i aria-hidden="true" class="fa fa-plus-square-o"></i> <router-link :to="{ name: 'editPdf' }"> Създай дани за pdf </router-link></li>
        <li v-else @click="openModalCreateFolder(false)"><i class="fa fa-plus-square-o" aria-hidden="true"></i> Създай папка</li>
        <li > <form action="#" enctype="multipart/form-data">

            <label for="uploadbtn" class="uploadButton"><i class="fa fa-cloud-upload" aria-hidden="true"></i> Загрузить файл</label>

            <input type="file" @change="fileInputChange" id="uploadbtn" placeholder="wdwd" multiple="multiple">
        </form></li>

    </ul>

    <ul class="buttons-do l-fe" v-else>
        <li @click="massActItem(checkBoxValue, 'copy')"> <i aria-hidden="true" class="fa fa-files-o"></i> Копирай</li>
        <li @click="massActItem(checkBoxValue, 'remove')"> <i class="fa fa-trash-o" aria-hidden="true"></i> Изтрий</li>
        <li @click="massActItem(checkBoxValue, 'move')"><i class="fa fa-power-off status colorGreen" aria-hidden="true"></i> Перемести</li>
    </ul>
    <mode ></mode>

</div>
  <!--   <div>
        <ul class="nav-page pb10">

            <li class="active"><router-link :to="{ name: 'files' }"> Всички файли </router-link></li>
            <li class="active"><router-link :to="{ name: 'filesPdf', params: { type: 'pdf' }  }"> pdf </router-link></li>

            <input class="search-product" placeholder="Търсяне в файли" style="float:right" type="text" v-model="search" @keyup="searchItems()">
        </ul>

    </div> -->
</nav>
<div class="content-place">
    <div v-if="loading" class="lds-dual-ring spinner"></div>
    <div >
        <div  class="table-content-place">



            <div v-for="(item,index) in items" :key="item.id"  class="ml0 row table header-table card-img-top imgs-sortable" @dblclick="clickImage(item)">

                <div class="col-lg-1" style="text-align:right">

                    <input @change="changeStateCheckbox(item)"  v-model="item.check" type="checkbox" :id="item.id" class="cbx" style="display: none;">
                    <label :for="item.id" class="check">
                      <svg width="14px" height="14px" viewBox="0 0 18 18">
                        <path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z"></path>
                        <polyline points="1 9 7 14 15 4"></polyline>
                    </svg>
                </label>

                <img :src="item.icon" alt="title">
            </div>
            <div class="col-lg-4 name" >
                <span :title="item.title">{{ item.title }}</span>
                <span class="type-folder"> {{ item.type }}</span>
            </div>

            <div class="col-lg-2">
                <span>{{ item.title }}</span>
            </div>
            <div class="col-lg-3">
                <span>{{ item.title }}</span>
            </div>
            <div class="col-lg-1">
               <span @click="activeOptions == item.id ? activeOptions = 0 : activeOptions = item.id"><i class="fa fa-ellipsis-h" aria-hidden="true"></i>

               </span>
               <div  class="wrap-option-folder-menu" v-if="activeOptions == item.id">
                <ul class="option-folder-menu  table-option-wrap">
                    <li v-if="item.type == 'folder'" @click="clickImage(item)"> Отвори</li>
                    <li v-if="item.type != 'pdf'" @click="openModalCreateFolder(item)"> Редактирай</li>
                    <li @click="openModalMoveFolder(item, 'move')"> Прехвърляне</li>
                    <li @click="openModalMoveFolder(item, 'copy')"> капиране</li>
                    <li  @click="removeFile(item, index)"> Изтрий</li>
                    <li v-if="item.type == 'pdf'"><router-link :to="{ name: 'file-edit-pdf', params: { id: item.id }  }"> Редактирай</router-link></li>
                </ul>
            </div>

        </div>

    </div>
    <!-- </draggable> -->
</div>

</div>

<div >
 <div class="empty-folder" v-if="items.length == 0 && loading == false">
    <img src="http://perpao.com/empty-folder.png" alt="">
    <div class="content-empty-folder">
        <h3>Нищо не намерено</h3>

    </div>

</div>
</div>

</div>

</div>
<ModalCreateFolder @addItemBottomFile="addItemBottomFile" @finishedEditFile="finishedEditFile"> </ModalCreateFolder>
<ModalMoveFolder @finishedMoveFile="finishedMoveFile" @finishedMoveFileMass="finishedMoveFileMass"> </ModalMoveFolder>



</div>
</template>

<script>

    import axios from 'axios'

    
    import mode from '../../../components/layouts/mode'

    import LeftSidebar from '../../../components/layouts/LeftSidebar'


    // mixins
    // import database from '../../../mixins/database'
    // import sortable from '../../../mixins/sortable'
    import filemanager from '../../../mixins/filemanager'
    import general from '../../../mixins/system/general'

    import ModalCreateFolder from '../../app_modules/ModalCreateFolder'
    import ModalMoveFolder from '../../app_modules/ModalMoveFolder'


    export default {
        name: 'shop-product',
        
        mixins: [filemanager, general],


        data() {
            return {

              dataBase: {
                selectFrom: this.$route.params.type ? 'files/'+this.$route.params.type : 'files' ,
            },



            search: '',

        }
    },

    created() {
        console.log(this.$route.params.type)
    },

    components: {
        LeftSidebar,
        mode,
        ModalCreateFolder,
        ModalMoveFolder,

    },



}

</script>

<style scoped src="../../../assets/css/page-index.css"></style>
<style scoped src="../../../assets/css/table.css"></style>
<style scoped>
.uploadButton {
    font-size: 13px;
    cursor: pointer;
}
input[type="file"] {
    display: none;
}
</style>




// WEBPACK FOOTER //
// src/components/system/files/index.vue